module.exports = __webpack_public_path__ + "media/memory-bank/level4-avatar-58c36175.png";